<template>
  <div class="navigation" v-if="!hiddenClick">
    <div :class="[position]" :style="{ transform: styleOne}" @click="changeSwiper">01</div>
    <div class="divider">/</div>
    <div :class="[position === 'left' ? 'right' : 'left']" :style="{ transform: styleTwo}" @click="changeSwiper">02</div>
  </div>
  <div class="navigation" v-else>
    <div class="left">{{currentIndex > 9 ? `${currentIndex}` : `0${currentIndex}` }}</div>
    <div class="divider">/</div>
    <div class="right">{{total > 9 ? total : `0${total}` }}</div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue'

const props = defineProps({
  hiddenClick: {
    type: Boolean,
    default: false
  },
  currentIndex: {
    type: Number,
    default: 0
  },
  total: {
    type: Number,
    default: 0
  }
})
const emit = defineEmits(['change'])

const styleOne = ref('translateX(0)')
const styleTwo = ref('translateX(0)')
const position = ref('left')

// 1920分辨率的情况下
function pxToRem (px) {
  return parseFloat(px / 192).toFixed(4) + 'rem'
}

function changeSwiper () {
  if (position.value === 'left') {
    styleOne.value = `translateX(${pxToRem(55)})`
    styleTwo.value = `translateX(-${pxToRem(55)})`
  } else {
    styleOne.value = 'translateX(0)'
    styleTwo.value = 'translateX(0)'
  }
  position.value = position.value === 'left' ? 'right' : 'left'
  emit('change', `${position.value === 'left' ? 'prev' : 'next'}`)
}
</script>

<style lang="scss">
.navigation {
  display: flex;
  position: relative;
  font-weight: 600;
  color: white;
  .left, .right {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    cursor: pointer;
    width: 55px;
    height: 39px;
    transition: transform 0.5s;
  }

  .left {
    font-size: 32px;
    position: relative;
    top: 3px;
  }
  .right {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.3);
  }

  .divider {
    position: absolute;
    z-index: 3;
    bottom: 3px;
    left: 55px;
    color: white;
    color: rgba(255, 255, 255, 0.3)
  }
}
</style>
